import cn from 'classnames'
import React from 'react'
import { NavLink, useHistory, useLocation, useParams } from 'react-router-dom'

export default function BuildingTabs() {
    const { buildId } = useParams()
    const history = useHistory()

    const location = useLocation()
    const handleBack = () => {
        history.push(`/building/${buildId}`)
    }
    return (
        <div className="tabs">
            <ul>
                <li style={{ cursor: 'pointer' }} onClick={handleBack}>
                    <span className="icon-text">
                        <span className="icon">
                            <ion-icon name="arrow-back-outline" />
                        </span>
                    </span>
                </li>
                <li style={{ cursor: 'pointer' }} className={cn({ 'is-active': location.pathname.startsWith(`/building/${buildId}/entrance`) })}>
                    <NavLink to={`/building/${buildId}/entrance`}>Падездлар</NavLink>
                </li>
                <li style={{ cursor: 'pointer' }} className={cn({ 'is-active': location.pathname.startsWith(`/building/${buildId}/apartment`) })}>
                    <NavLink to={`/building/${buildId}/apartment`}>Квартиралар</NavLink>
                </li>
                <li style={{ cursor: 'pointer' }} className={cn({ 'is-active': location.pathname.startsWith(`/building/${buildId}/customer`) })}>
                    <NavLink to={`/building/${buildId}/customer`}>Мижозлар</NavLink>
                </li>
                <li style={{ cursor: 'pointer' }} className={cn({ 'is-active': location.pathname.startsWith(`/building/${buildId}/contract`) })}>
                    <NavLink to={`/building/${buildId}/contract`}>Шартномалар</NavLink>
                </li>
                <li style={{ cursor: 'pointer' }} className={cn({ 'is-active': location.pathname.startsWith(`/building/${buildId}/payment`) })}>
                    <NavLink to={`/building/${buildId}/payment`}>Тўловлар</NavLink>
                </li>
            </ul>
        </div>
    )
}
